export default __webpack_public_path__ + "static/media/My_car_website_images-13_22.dd224834.jpg";